






























































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import store from "@/store/store";
import moment from "moment";
import axios from "axios";
import SignatureEntry from "./SignatureEntry.vue";
import { loadParts } from "@/common/jobLoader";
import { ActionNames } from "@/store/actions";

export interface JobStatusDetail {
  StatusId: string;
  StatusDetail: string;
  Description: string;
}

@Component({
  components: {
    SignatureEntry,
  },
})
export default class CompleteJob extends Vue {
  statusDetails: JobStatusDetail[] = [];
  selectedStatusDetail?: JobStatusDetail = {
    StatusId: "",
    StatusDetail: "",
    Description: "",
  };
  @Prop()
  public showDialog: boolean = false;
  public internalShowDialog: boolean = false;
  private startTime: moment.Moment = moment().set({
    hour: 0,
    minute: 0,
  });
  private finishTime: moment.Moment = moment().set({
    hour: 0,
    minute: 0,
  });
  private liftIsSafe: boolean = false;
  private signatory: string = "";
  private email: string = "";

  // Watchers so that element dialog .sync works with a prop
  @Watch("showDialog")
  public updateInternal() {
    this.internalShowDialog = this.showDialog;
    // If we are showing the dialog box set the needed values
    // Can't be done on created/mounted as the dialog box is created and hidden before
    // The signature button is clicked.
    if (this.internalShowDialog === true) {
      this.setUpDialog();
    }
  }

  @Watch("internalShowDialog")
  public updateExternal() {
    if (!this.internalShowDialog) {
      this.clearSignature();
      this.closeDialog();
    }
  }

  public displayTime(date: moment.Moment) {
    return date.isValid() ? date.format("HH:mm") : "00:00";
  }

  public clearSignature() {
    (this.$refs.signatureEntry as SignatureEntry).clearSignature();
  }

  public closeDialog() {
    this.$emit("completeJobClosed");
  }

  private setUpDialog() {
    this.startTime =
      store.state.Job.ExamDetail!.ArrivedOnSite ||
      moment().set({
        hour: 0,
        minute: 0,
      });
    this.finishTime = moment();
    this.liftIsSafe = store.state.Job.ExamDetail!.LiftSafe || false;
    this.signatory = "";
    this.email = store.state.Job.JobDetail!.ContactEmail || "";
    this.getStatusDetails();
  }
  async getStatusDetails() {
    // Gets available status details for job complete
    const response = await axios.get(
      `${store.state.Environment.ODataBaseUrl}/ProblemStatusDetails?` +
        `$select=StatusId,StatusDetail,Description` +
        `&$filter=StatusId eq 'COMPLT' and Obsolete eq 0` +
        `&$orderby=Sequence asc`,
      {
        headers: {
          Authorization: "Bearer " + store.state.User.AccessToken,
        },
      }
    );
    if (response.status === 200 && response.data) {
      this.statusDetails = response.data.value;
      this.selectedStatusDetail = this.statusDetails[0];
    }
  }

  statusDetailSelected(detail: JobStatusDetail) {
    this.selectedStatusDetail = detail;
  }

  private async completeJob() {
    // Set the loading spinner while we do work
    const savingJob = this.$loading({
      target: ".complete-job .el-dialog",
    });

    const signature = (this.$refs.signatureEntry as SignatureEntry).getData();
    // validate dialog info
    if (signature === "") {
      this.$notify.error({
        title: "Error",
        message: "A signature is required",
        offset: 48,
      });
    } else if (this.signatory === "") {
      this.$notify.error({
        title: "Error",
        message: "The Signatory field is requied",
        offset: 48,
      });
    } else if (this.email === "") {
      this.$notify.error({
        title: "Error",
        message: "The email field is requied",
        offset: 48,
      });
    } else {
      try {
        await store.dispatch(ActionNames.CloseJob, {
          signature,
          signatory: this.signatory,
          email: this.email,
          statusDetailId:
            this.selectedStatusDetail && this.selectedStatusDetail.StatusDetail
              ? this.selectedStatusDetail.StatusDetail
              : undefined,
        });
        this.$root.$emit("refreshJobList");
        savingJob.close();
        this.$router.push("/");
      } catch (err) {
        this.$notify.error({
          title: "Error",
          message: "Failed to complete job",
          offset: 48,
        });
      }
    }
    savingJob.close();
  }
}
